import * as React from 'react';

import { RouteStore } from 'bernie-core';
import { PriceViewModel } from 'models';
import { Text } from 'components/common/text';
import { inject } from 'mobx-react';
import { StrikeoutPriceAndInfoContainer } from './strikeout-price-and-info-container';
import { LeadPrice } from './lead-price';

export interface PriceProps {
  className: string | string[];
  diff?: string;
  messages?: string[];
  price: PriceViewModel;
  alignmentClasses?: string;
  routeStore?: RouteStore;
  hotelId?: number;
  priceFontWeight: string;
  wrapPrice?: boolean;
  id?: string;
}

interface AlignmentClasses {
  alignmentClasses?: string;
  query?: any;
  dialogId?: string;
  handleClose?: () => void;
  priceFontWeight: string;
  wrapPrice?: boolean;
  dialogType?: string;
}

type PriceViewModelWithAlignment = PriceViewModel & AlignmentClasses;

@inject('routeStore')
export class Price extends React.Component<PriceProps, {}> {
  constructor(props) {
    super(props);

    this.routeStoreGoBack = this.routeStoreGoBack.bind(this);
  }

  public static defaultProps: Partial<PriceProps> = {
    alignmentClasses: 'all-grid-align-middle all-grid-align-end'
  };

  public render() {
    const { alignmentClasses, className, price, messages, diff, routeStore, hotelId, priceFontWeight, wrapPrice, id } = this.props;

    if (!price) {
      return null;
    }

    const priceMessage = price && price.priceMessage;

    const additionalMessages =
      messages &&
      messages.map((message, idx) => (
        <div key={idx} className="uitk-cell pwa-theme--grey-700 uitk-type-100" data-stid="additional-messages">
          {message}
        </div>
      ));

    const isPwaDialogNested = id === 'infosite-room-info-dialog-ratePlans';
    const dialogId = hotelId ? `priceDisclaimerDialog-${hotelId}` : 'priceDisclaimerDialog';
    const pwaDialog = isPwaDialogNested ? { pwaDialogNested: dialogId } : { pwaDialog: dialogId };
    const dialogType = isPwaDialogNested ? 'pwaDialogNested' : 'pwaDialog';
    const dialogQuery = routeStore.mergeQueryString(routeStore.search, pwaDialog);
    const query = { pathname: routeStore.pathname, search: dialogQuery };

    return (
      <div data-stid="content-hotel-price" className={`price ${className || ''}`}>
        {!priceMessage && diff && <PriceDiff price={price} diff={diff} alignmentClasses={alignmentClasses} />}
        {!priceMessage &&
          !diff && (
            <PriceValues
              {...price}
              {...{ alignmentClasses, query, dialogId, priceFontWeight, wrapPrice, dialogType }}
              handleClose={this.routeStoreGoBack}
            />
          )}
        {additionalMessages}
        {priceMessage && <PriceDescription {...priceMessage} />}
      </div>
    );
  }

  private routeStoreGoBack() {
    this.props.routeStore.goBack();
  }
}

const PriceDiff = ({ price, diff, alignmentClasses }) => {
  const { lead, label, numberOfNightsAndRooms } = price;

  return (
    <React.Fragment>
      <div className={`uitk-grid ${alignmentClasses}`}>
        <span className="uitk-cell all-cell-shrink uitk-type-500 uitk-type-bold" data-stid="content-hotel-display-price">
          {diff}
        </span>
      </div>
      {lead &&
        label && (
          <span className="uitk-type-100 uitk-type-medium pwa-theme--grey-700">
            {lead}
            {label}
          </span>
        )}
      {numberOfNightsAndRooms && (
        <div className="numberOfNightsAndRooms pwa-theme--grey-700 uitk-type-100 uitk-type-regular">{numberOfNightsAndRooms}</div>
      )}
    </React.Fragment>
  );
};
PriceDiff['displayName'] = 'PriceDiff';

const PriceValues = ({
  lead,
  strikeOut,
  label,
  numberOfNightsAndRooms,
  alignmentClasses,
  strikeoutDisclaimer,
  query,
  dialogId,
  handleClose,
  priceFontWeight,
  wrapPrice,
  dialogType
}: PriceViewModelWithAlignment) => (
  <React.Fragment>
    <div className={`uitk-grid ${alignmentClasses}`}>
      {strikeOut && (
        <StrikeoutPriceAndInfoContainer {...{ strikeoutDisclaimer, query, strikeOut, dialogId, handleClose, wrapPrice, dialogType }} />
      )}
      <LeadPrice {...{ label, lead, priceFontWeight, wrapPrice, strikeOut }} />
    </div>
    {numberOfNightsAndRooms && (
      <div className="numberOfNightsAndRooms pwa-theme--grey-700 uitk-type-100 uitk-type-regular">{numberOfNightsAndRooms}</div>
    )}
  </React.Fragment>
);
PriceValues['displayName'] = 'PriceValues';

const PriceDescription = ({ text, theme }: PriceViewModel['priceMessage']) => {
  const themeValue = Text.theme[theme] ? Text.theme[theme] : theme; // TODO: Can remove once we switch to BEX API

  return (
    text && (
      <span className={'uitk-type-300 uitk-type-medium'} data-stid="content-hotel-sold-out">
        <Text theme={themeValue}>{text}</Text>
      </span>
    )
  );
};
PriceDescription['displayName'] = 'PriceDescription';
